import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import type { BaseFlagProps } from './common/ui/types.tsx';
import { IssueLimitFlags } from './ui/index.tsx';

type Props = BaseFlagProps;

const App = (props: Props) => (
	<JSErrorBoundary
		id="app"
		packageName="jiraSoftwareIssueLimitFlags"
		teamName="a4t-tanuki"
		fallback="flag"
	>
		<IssueLimitFlags {...props} />
	</JSErrorBoundary>
);

export default App;
